
import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';

//Service
import { ComplianceService } from './../../../services/compliance.service';
import { ExportService } from '../../../services/exporter.service';

//Model
import { FileExport } from '../../../model/exporter.model';
import { DriverFitnessTest } from './../../../model/compliance.model';
import { Url } from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';

@Component({
    selector: 'app-driverfitnesstests',
    templateUrl: './driverfitnesstests.component.html',
    styleUrls: ['./driverfitnesstests.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ ComplianceService ]
  })
  
  export class DriverFitnessTestsComponent implements OnInit {
    @LocalStorage() url!: Url;
    @LocalStorage() themeSettings: ThemeSetting;

    public fileStoragePath = this.url.fileStorage;

    rows = [];
    dft : DriverFitnessTest[];
    selected = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    dftCount: number = 0;

    showDate:boolean=true;
    showDriver:boolean=true;
    showDriverLicence:boolean=true;
    showStatus:boolean=true;
    showFile:boolean=true;
    
    //Handles the name, type and content of the to-be exported file
    public exp_excel: FileExport;
    public exp_pdf: FileExport;

    //Stores the filtered and formatted content of the file
    formatted_list : any;

    columns = [
        { prop:'id'},
        { prop:'driver_id'},
        { prop:'is_compliant'},
        { prop:'date_done'},
        { prop:'time_done'},
        { prop:'manifest_id'},
        { prop:'file'},
        { prop:'driver_first_name'},
        { prop:'driver_last_name'}

      ];
    
    constructor(  private http: HttpClient, 
                  private complianceService: ComplianceService,
                  private exporter: ExportService
                  ){
              
    }

    ngOnInit() {
      this.getDriverFitnessTests();

      //Declaration to handle the name, type and content of the file
      this.exp_excel = {title:'', list_data:'', type:''};
      this.exp_pdf = {title:'', list_data:'', type:''};

    }

    getDriverFitnessTests(){
      this.complianceService.getDriverFitnessTests().toPromise().then(data=>{
        if (data["driver_tests"].length > 0)
          this.selected = [data["driver_tests"][0]];
          this.rows = data["driver_tests"];
          this.fullRowsDriverFitnessTests = data["driver_tests"];
          this.dftCount = this.rows.length;
          
          console.log(data);
      }).finally(()=> setTimeout(() => { this.loadingIndicator = false; }));
    }

    private formatDate(inDate: string) {
      let formatedDate: Date;
      formatedDate = new Date(inDate.replace(/-/g, "/"));
      return formatedDate;
    }

    print(): void {
      let printContents, popupWin;
      printContents = document.getElementById('print-section').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
        <title>Drivers Fitness Tests List</title>
        <style>
        @page {
          size: A4;
        }

        table {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;
          border: 1px solid #ddd !important;
      }

      th, td {
          text-align: left;
          padding: 16px;
      }


      tr:nth-child(even) {
          background-color: #f2f2f2 !important;
          box-shadow: inset 0 0 0 1000px #f2f2f2;
      }

      .fn {
        float: footnote;
      }

      thead {
        box-shadow: inset 0 0 0 1000px #f2f2f2;
      }
        
          
      </style>
      </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
    }

    showFilters: boolean = false;
    filterDDriver: string = '';
    filterDDate: Date;
    isFilterEmpty: boolean = true;
    tempDriverFitnessTests = [];
    fullRowsDriverFitnessTests = [];

    public toggleFilters() {
      if (this.showFilters) this.showFilters = false;
      else this.showFilters = true;
    }

    updateFilter() {
      this.isFilterEmpty = false;

      this.tempDriverFitnessTests = this.fullRowsDriverFitnessTests.filter(data => { 
        if (data.date_done && this.filterDDate){
          return (new Date(data.date_done).toString() === new Date(this.filterDDate).toString());
        }else{
          return data.date_done;
        };
      });

      this.tempDriverFitnessTests = this.tempDriverFitnessTests.filter(data => {
       if (this.filterDDriver && data.driver_first_name){
          return (data.driver_first_name + ' ' + data.driver_last_name).toLowerCase().indexOf(this.filterDDriver.toLowerCase()) !== -1 || !this.filterDDriver.toLowerCase();    
        }else{
          return (data.driver_first_name + ' ' + data.driver_last_name);
        }
      });

      this.rows = this.tempDriverFitnessTests;
      this.dftCount = Object.keys(this.tempDriverFitnessTests).length;
    }

    public resetFilters() {
      this.filterDDriver = '';
      this.filterDDate = null;
      this.rows = this.fullRowsDriverFitnessTests;
      this.isFilterEmpty = true;
      this.dftCount = Object.keys(this.rows).length;

    }

   /*** Export... Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  driverFitTest_generateHeaders(list_driverFitTest): any{
    const arr = JSON.parse(list_driverFitTest);
    arr.forEach( obj => {
      this.renameKey( obj, 'date_done', 'Date' );
      this.renameKey( obj, 'driver_first_name', 'Driver' );
      this.renameKey( obj, 'driver_license_no', 'Driver License #' );
      this.renameKey( obj, 'is_compliant', 'Status' );
      this.renameKey( obj, 'file', 'File' );
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
  }

  //Filters every column in the table list
  driverFitTest_generateColumnsWithFilter(list_driverFitTest){
      const arr = JSON.parse(JSON.stringify(list_driverFitTest));
      arr.forEach( obj => {
        //Merge First and Last Names in the list
        obj['driver_first_name'] =  obj['driver_first_name'] + ' ' + obj['driver_last_name'];

        //To display appropriate driver check status
        if(obj['is_compliant'] == 1)
          obj['is_compliant'] = 'Compliant';
        else
          obj['is_compliant'] = 'Non-Compliant';

        //Format date
        obj['date_done'] = formatDate(obj['date_done'], 'dd MMM yyyy', 'en_US');

        //remove filtered columns
        if(!this.showDate){
          delete obj['date_done'];
        };
        if(!this.showDriver){
          delete obj['driver_first_name'];
        };
        if(!this.showDriverLicence){
          delete obj['driver_license_no'];
        };
        if(!this.showStatus){ 
          delete obj['is_compliant'];
        };
        if(!this.showFile){
          delete obj['file'];
        };
        delete obj['id'];
        delete obj['driver_id'];
        delete obj['driver_last_name'];
        delete obj['time_done'];
        delete obj['manifest_id'];
        delete obj['created_at'];
        delete obj['updated_at'];
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
  }

  //Exports  table to CSV file
  driverFitTest_exportToCSV(){
      if(this.rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.driverFitTest_generateColumnsWithFilter(this.rows);

          //generate json with format header
          this.formatted_list = this.driverFitTest_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Compliance_Driver_Fitness_Tests_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Compliance - Driver Fitness Tests');
      }
  };

  //Exports Current Jobs table to PDF file
  driverFitTest_exportToPDF(){
    if(this.rows.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.driverFitTest_generateColumnsWithFilter(this.rows);

      //generate json with format header
      this.formatted_list = this.driverFitTest_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();

      let pdf_file = '[TMS]Compliance_Driver_Fitness_Tests_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'DRIVER FITNESS TESTS';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports table to MS Excel file
  driverFitTest_exportToExcel(){
      if(this.rows.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.driverFitTest_generateColumnsWithFilter(this.rows);

          //generate json with format header
          this.formatted_list = this.driverFitTest_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Compliance_Driver_Fitness_Tests_' + this.formattedDate(current_date);
          this.exp_excel.title = 'DRIVER FITNESS TESTS';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              console.log(data);
              saveAs(data, excel_file)

          });
      }
  }; 

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }
}